export default __webpack_public_path__ + "static/media/beneficios-navegacao-diarios.5c224aff.png";